Billy.InvoiceLine.reopen({
    // This is a planned property, that has been added in invoice-resource
    // For now, this computed property will just return the up-to-date rate from the TaxRate model
    currentTaxRate: Em.computed.alias('taxRate.rate')
})
